import { EBillingPeriodType } from "../../Enum/EBillingPeriodType"

export class AdminPlanPeriod {
  id: number

  eBillingPeriodType: EBillingPeriodType

  price: number

  isActive: boolean

  constructor(data: Partial<AdminPlanPeriod> = {}) {
    this.id = data.id ?? 0

    this.eBillingPeriodType = data.eBillingPeriodType ?? EBillingPeriodType.Monthly

    this.price = data.price ?? 0

    this.isActive = data.isActive ?? true
  }
}
